'use client';

import React from 'react';
import { Carousel as AuiCarousel } from '../../Carousel';
import { useDeviceDetect } from '../../../util';
import { useMediaQuery } from '../../../util/hooks';
import { Size } from '../../../abstracts/breakpoints';
import { styled } from 'styled-components';
const Container = styled.div.withConfig({
  componentId: "aui__sc-30gitw-0"
})(["padding-bottom:1rem;"]);
export const Carousel = ({
  children
}) => {
  const {
    isMobile
  } = useDeviceDetect();
  const isSmallDesktop = !useMediaQuery(`(min-width: ${Size.MD}px)`);
  const handleScrollHint = (isMobile, isSmallDesktop) => {
    if (isMobile) return 0.5;else if (isSmallDesktop) return 0.25;else return 0;
  };
  const scrollHint = handleScrollHint(isMobile, isSmallDesktop);
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(AuiCarousel, {
    elementRole: "none",
    gapSize: 0,
    minWidth: isMobile ? 6.5 : 5.5,
    options: {
      hideScrollbar: true,
      scrollHint: scrollHint,
      suggestiveFade: false
    },
    maxColumns: isMobile ? 5 : 7,
    showArrowOnDesktop: true,
    showArrowOnMobile: false
  }, children));
};